import React, { forwardRef } from 'react';
import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  Box,
  Typography
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

const Accordion = forwardRef(({
  title,
  titleContent,
  children,
  defaultExpanded = false,
  expanded,
  onChange,
  rightIcon,
  onRightIconClick,
  expandIcon,
  sx = {},
  summaryContent,
  detailsContent,
  ...props
}, ref) => {
  return (
    <MuiAccordion
      defaultExpanded={defaultExpanded}
      expanded={expanded}
      onChange={onChange}
      sx={{
        mb: 1.5,
        '&.Mui-expanded': {
          margin: 0,
        },
        ...sx
      }}
      {...props}
    >
      <MuiAccordionSummary
        sx={{
          backgroundColor: '#f5f8fb',
          borderRadius: '4px',
          position: 'relative',
          margin: 0,
          minHeight: 0,
          padding: '10px',
          '&.Mui-expanded': {
            margin: 0,
            minHeight: 0,
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            display: expandIcon === false ? 'none' : 'flex',
          },
          '& .MuiAccordionSummary-content': {
            margin: 0,
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
          }
        }}
      >
        {summaryContent || (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between'
          }}>
            {titleContent || (
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 500,
                  fontSize: "16px !important",
                  maxWidth: rightIcon ? '85%' : '100%',
                  lineHeight: 1.3
                }}
              >
                {title}
              </Typography>
            )}
            {rightIcon && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  flexDirection: "column",
                  justifyContent: "center"
                }}
                onClick={(e) => {
                  if (onRightIconClick) {
                    e.stopPropagation();
                    onRightIconClick(e);
                  }
                }}
              >
                {rightIcon}
                {expandIcon !== false && (
                  <Box
                    sx={{
                      display: 'flex',
                      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                    }}
                  >
                    <ExpandMoreIcon fontSize="small" />
                  </Box>
                )}
              </Box>
            )}
          </Box>
        )}
      </MuiAccordionSummary>
      <MuiAccordionDetails
        sx={{
          p: 2,
          backgroundColor: '#ffffff',
          position: 'relative',
        }}
      >
        {detailsContent || children}
      </MuiAccordionDetails>
    </MuiAccordion>
  );
});

Accordion.displayName = 'Accordion';

export default Accordion;